<template>
  <div class="big-screen">
    <top @change="showChange" :name="getName" :list="list"/>
    <div class="info-body" ref="infoBody">
      <gltf :id="getId" :parkCode="getParkCode"/>
      <left-row :infoData="infoData"/>
      <div class="center-row">
        <i class="el-icon-warning-outline"/>
        点击左右切换按钮即可实现园区/写字楼切换
      </div>
      <right-row :infoData="infoData"/>
    </div>
  </div>
</template>

<script>
import Top from './top.vue'
import Gltf from './GLTF.vue'
import LeftRow from './leftRow.vue'
import RightRow from './rightRow.vue'
import { getDetail } from '@/api/bigScreen'
import { baseParkInfo } from '@/api/basicInfo'
export default {
  data () {
    return {
      infoData: {},
      showIndex: 0,
      list: []
    }
  },
  computed: {
    getName () {
      return (this.list?.[this.showIndex] || {}).name
    },
    getId () {
      return (this.list?.[this.showIndex] || {}).id
    },
    getParkCode () {
      return (this.list?.[this.showIndex] || {}).parkCode
    }
  },
  components: {
    Top,
    LeftRow,
    Gltf,
    RightRow
  },
  methods: {
    // 查询所有园区
    getAll () {
      baseParkInfo('query', {}).then(res => {
        console.log(res, 'queryquery')
        const { code, result } = res
        if (code !== 0) return
        this.list = result.records.map((item) => {
          return {
            name: item.parkName,
            id: item.id,
            parkCode: item.parkCode
          }
        })
        this.handleShowBigScreen()
        if (this.list.length > 0) {
          this.getInfo()
        }
      })
    },
    getInfo () {
      let id = (this.list?.[this.showIndex] || {})?.id
      if (id === undefined) return
      getDetail({ id }).then(res => {
        console.log(res)
        const { code, result } = res
        if (code !== 0) return
        this.infoData = { ...result }
      })
    },
    showChange (type) {
      let index = this.showIndex
      switch (type) {
        case 'reduce':
          index -= 1
          if (index < 0) index = this.list.length - 1
          break;
        case 'plus':
          index += 1
          if (index >= this.list.length) index = 0
          break;
        default:
          index = type
      }
      this.showIndex = index
      this.getInfo()
    },
    handleShowBigScreen() {
      console.log(this.$route.query.parkCode);
      console.log(this.list);
      if (this.$route?.query?.parkCode) {
        let findIndex = this.list.findIndex(v => v.parkCode === this.$route?.query?.parkCode)
        console.log(findIndex, 'findIndexfindIndex');
        this.showIndex = findIndex
      }
    }
  },
  mounted () {
    this.getAll() 
  },
}
</script>

<style lang="scss" scoped>
.big-screen {
  background: url("~@/assets/images/bigScreen/bg-mb.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 0.75rem;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  .info-body {
    height: 100%;
    padding: 0 0.3rem;
    box-sizing: border-box;
    position: relative;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.1rem;
    .center-row {
      position: absolute;
      color: #A1BFDB;
      font-size: 0.18rem;
      top: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      background: rgba($color: #0B253E, $alpha: 0.5);
      padding: 0.04rem 0.2rem;
      border-radius: 0.04rem;
    }
  }
}
</style>